import { useEffect, useMemo } from 'react'
import { openModal, closeAllModals } from '@mantine/modals'
import { LoadingOverlay, Global } from '@mantine/core'
import { last, pick, castArray } from 'lodash-es'
import {
  useTbViewStore,
  TbViewProvider,
  useAppEx,
  useFetchRemoteData,
  useBeforeTransform,
  useProjectStore,
} from '@vt/hooks'
import { Table } from '@ow/ditto'
import { CloseIcon } from '@ow/icons'
import { DittoProvider } from '@ow/ditto-core'
import { upload, addWatermarkToImage } from '@vt/apis/lib-ex/v2/givrali'
import Pagination from '../container/pagination'

const openDetailModal = (currentData) => {
  openModal({
    modalId: currentData.objectId,
    children: <PureDetail currentData={currentData} />,
  })
}

const ShowTable = ({ showData, beforeTransform }) => {
  const {
    loading,
    tbData = [],
    fields,
    listConfig,
    columnShowType,
    setFilters,
  } = useTbViewStore((state) =>
    pick(state, [
      'fields',
      'tbData',
      'setFilters',
      'loading',
      'listConfig',
      'columnShowType',
    ])
  )

  const config = useMemo(() => {
    return {
      ...listConfig,
      fields: columnShowType,
    }
  }, [listConfig, columnShowType])

  useEffect(() => {
    const std = last(castArray(last(showData.standard)))
    const areaId = showData.area ? last(showData.area).objectId : null
    const standardId = showData.standard ? std && std.objectId : null
    const lnglat = showData.lnglat ? [...showData.lnglat, 0.1] : null

    const queries = []
    if (areaId) {
      queries.push({
        slug: 'area',
        value: areaId,
        queryType: ['containArray'],
      })
    }
    if (standardId) {
      queries.push({
        slug: 'standard',
        value: standardId,
        queryType: ['containArray'],
      })
    }
    if (lnglat) {
      queries.push({
        slug: 'lnglat',
        value: lnglat,
        queryType: ['lnglat'],
      })
    }

    setFilters({
      queries,
      logicType: 'and',
    })
  }, [])

  return (
    <div
      className="flex flex-col relative h-full"
      style={{
        width: '85vw',
        background: '#fff',
        borderRadius: '4px',
      }}
    >
      <div
        className="w-full flex items-center h-14 px-4 justify-between"
        style={{
          fontSize: '1rem',
          fontWeight: 'bold',
          borderBottom: '1px solid #E7E7E7',
          color: 'rgba(0,0,0,0.90)',
        }}
      >
        <span>相似案件</span>

        <div className="cursor-pointer z-10" onClick={closeAllModals}>
          <CloseIcon width={18} height={18} fill="currentColor" />
        </div>
      </div>
      <div className="w-full flex-1 overflow-hidden flex flex-col items-end justify-between">
        {loading && <LoadingOverlay />}
        <div className="flex-1 h-full w-full overflow-hidden">
          <Table
            fields={fields}
            tbData={tbData}
            config={config}
            isRenderOperateTable={false}
            beforeTransform={beforeTransform}
          />
        </div>
        <Pagination />
      </div>
    </div>
  )
}

const PureDetail = ({ currentData }) => {
  const { appId } = useAppEx((state) => pick(state, ['appId']))
  const { tbId, id } = useTbViewStore((state) => pick(state, ['tbId', 'id']))

  const fetchRemoteData = useFetchRemoteData()
  const { customCompsMap } = useProjectStore((state) =>
    pick(state, ['customCompsMap'])
  )

  const beforeTransform =
    customCompsMap && customCompsMap.useBeforeTransform
      ? customCompsMap.useBeforeTransform({})
      : useBeforeTransform({})

  return (
    <DittoProvider
      tbId={tbId}
      onFetchRemoteData={fetchRemoteData}
      upload={upload}
      addWatermarkToImage={addWatermarkToImage}
      beforeTransform={beforeTransform}
    >
      <TbViewProvider appId={appId} tbId={tbId} vid={id}>
        <Global
          styles={() => ({
            '.mantine-Modal-modal': {
              width: 'unset',
              height: '100%',
              display: 'flex',
              flexDirection: 'column',
            },
            '.mantine-Modal-header': {
              display: 'none',
            },
            '.mantine-Modal-body': {
              flex: 1,
              height: '100%',
              overflow: 'hidden',
              '.mantine-y7yj5k': {
                overflow: 'hidden',
                height: '100%',
              },
            },
          })}
        />
        <ShowTable showData={currentData} beforeTransform={beforeTransform} />
      </TbViewProvider>
    </DittoProvider>
  )
}

export { openDetailModal as showSimilarUcase }
